import { Avatar, Button, Card, Checkbox, Col, Collapse, Form, Input, InputNumber, List, Modal, Row, Select, Space, Tabs } from 'antd';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { AppContext } from '../../contexts/AppContext';
import { trim } from 'lodash';

const TralitSettings: React.FC<any> = (props) => {
  const { tralitSettings, setTralitSettings, event$, authInfo } = useContext(AppContext);
  const { showSettings, setShowSettings, modalWidth, modalHeight } = props;

  let defaultModalHeight = 500;
  let defaultModalWidth = 500;

  if (typeof window !== 'undefined') {
    defaultModalHeight = document.body.clientHeight - 300;
    defaultModalWidth = document.body.clientWidth * 0.5;
  }

  const accountOptions = useMemo(() => {
    const client_account = authInfo.user?.attributes['custom:client_account'];
    const clientAccounts = client_account ? client_account.split(',').map((item) => trim(item)) : [];
    const tempAccounts = [
      {
        value: 'sbt',
        label: 'SBT',
      },
      {
        value: 'iwatani',
        label: '岩谷産業',
        disabled: true,
      },
      {
        value: 'toshiba',
        label: '東芝',
      },
      {
        value: 'toshiba_v2',
        label: '東芝v2',
      },
      {
        value: 'toyo-eng',
        label: '東洋エンジニアリング',
        disabled: true,
      },
      {
        value: 'toyo-tires',
        label: 'トーヨータイヤ',
        disabled: true,
      },
    ];
    return tempAccounts.filter((account) => clientAccounts.includes(account.value));
  }, [authInfo]);

  const [form] = Form.useForm();
  const fontSize = Form.useWatch('fontSize', form);

  const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  const onFinish = (values: any) => {
    setTralitSettings({ ...tralitSettings, ...values });
    localStorage.setItem('tralitSettings', JSON.stringify({ ...tralitSettings, ...values }));
  };

  const tabItems = useMemo((): any[] => {
    return [
      {
        label: 'アカウント',
        key: 1,
        children: (
          <>
            <Form.Item {...layout} name="account" label="アカウント" rules={[{ required: true }]}>
              <Select options={accountOptions} />
            </Form.Item>
            <Form.Item {...layout} name="key" label="セキュアKEY" rules={[{ required: true }]}>
              <Input.Password placeholder="セキュアKEY" />
            </Form.Item>
          </>
        ),
      },
      {
        label: 'プリファレンス',
        key: 2,
        children: (
          <div style={{ height: '100%', overflowY: 'scroll' }}>
            <Form.Item {...layout} name="fontSize" label="文字サイズ" rules={[{ required: true }]}>
              <Select placeholder="文字サイズ" onChange={() => {}}>
                <Select.Option value="大">大</Select.Option>
                <Select.Option value="中">中</Select.Option>
                <Select.Option value="小">小</Select.Option>
                <Select.Option value="custom">カスタム</Select.Option>
              </Select>
            </Form.Item>
            {fontSize === 'custom' && (
              <>
                <Form.Item {...layout} name="menu" label="メニュー">
                  <InputNumber min={12} max={24} />
                </Form.Item>
                <Form.Item {...layout} name="title" label="タイトル">
                  <InputNumber min={12} max={24} />
                </Form.Item>
                <Form.Item {...layout} name="chartTitle" label="チャットタイトル">
                  <InputNumber min={12} max={24} />
                </Form.Item>
                <Form.Item {...layout} name="tableTitle" label="データ表タイトル">
                  <InputNumber min={12} max={24} />
                </Form.Item>
                <Form.Item {...layout} name="tag" label="タグ">
                  <InputNumber min={12} max={24} />
                </Form.Item>
                <Form.Item {...layout} name="chart" label="チャット">
                  <InputNumber min={12} max={24} />
                </Form.Item>
                <Form.Item {...layout} name="table" label="データ表">
                  <InputNumber min={12} max={24} />
                </Form.Item>
              </>
            )}
          </div>
        ),
      },
    ];
  }, [fontSize, accountOptions]);

  return (
    <>
      <Modal
        title="設定"
        onOk={() => {
          setShowSettings(false);
        }}
        onCancel={() => {
          setShowSettings(false);
        }}
        width={modalWidth || defaultModalWidth}
        centered
        classNames={{ body: 'custom-scrollbar' }}
        styles={{
          body: {
            overflow: 'hidden',
            height: modalHeight || defaultModalHeight,
          },
        }}
        open={showSettings}
        footer={[
          <Button
            type="primary"
            key="ok"
            onClick={() => {
              form.submit();
              setShowSettings(false);
            }}
          >
            Save
          </Button>,
        ]}
      >
        <Form {...layout} form={form} name="control-hooks" initialValues={tralitSettings} onFinish={onFinish} style={{ height: '100%' }}>
          <Tabs tabPosition="left" items={tabItems} style={{ height: '100%' }} className="settings-tab" />
        </Form>
      </Modal>
    </>
  );
};

export default TralitSettings;
